import { VirtualClinicAnalysisFullyInpatientCaseOperatingNumber } from './term-fully-inpatient-case-operating-number';
import { VirtualClinicAnalysisOperatingNumberConstant } from './term-constant';
import { VirtualClinicAnalysisOperatingNumberFunction } from './term-function';
import { VirtualClinicAnalysisVirtualClinicOperatingNumber } from './virtual-clinic-operating-number';
import type { VirtualClinicAnalysisOperatingNumberTerm } from './term';
import type { FilterRegistrationToken } from '@bindoc-projects/filter-condition-domain-lib';

export class VirtualClinicAnalysisOperatingNumberTermFactory {
  public static async fromObject(
    obj: any = {},
    registeredFilter: FilterRegistrationToken[],
  ): Promise<VirtualClinicAnalysisOperatingNumberTerm> {
    let term = null;

    obj = obj ?? {};

    switch (obj.type) {
      case 'fullyInpatientCaseOperatingNumber':
        term =
          await VirtualClinicAnalysisFullyInpatientCaseOperatingNumber.fromObject(
            obj,
            registeredFilter,
          );
        break;
      case 'constant':
        term = Promise.resolve(
          VirtualClinicAnalysisOperatingNumberConstant.fromObject(obj),
        );
        break;
      case 'function':
        term = await VirtualClinicAnalysisOperatingNumberFunction.fromObject(
          obj,
          registeredFilter,
        );
        break;
      case 'virtualClinicOperatingNumber':
        term = Promise.resolve(
          VirtualClinicAnalysisVirtualClinicOperatingNumber.fromObject(obj),
        );
        break;
    }

    return term;
  }
}
